import { ArrowRight, ArrowUp, CalendarDays, Check, Mic, Sparkles } from 'lucide-react'
import './product-flow-loop.css'

/** A quiet, illustrative loop of the review path shown beside the live demo. */
export function ProductFlowLoop() {
  return (
    <section className="px-6 pb-16 md:pb-24" aria-labelledby="product-flow-title">
      <div className="mx-auto max-w-6xl">
        <div className="mb-9 max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">From thought to queue</p>
          <h2 id="product-flow-title" className="mt-3 text-3xl font-semibold tracking-tight md:text-4xl">
            The part between having an idea and hitting post.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground">
            Start rough. Shape the draft in chat. Put it in your queue only when it sounds like you.
          </p>
        </div>

        <div className="product-flow rounded-[1.75rem] border border-border bg-card p-4 sm:p-6 md:p-8">
          <div className="mb-5 flex items-center justify-between gap-3 text-xs text-muted-foreground">
            <span className="font-medium text-foreground">A little X11 workflow</span>
            <span>Illustrative example</span>
          </div>
          <div className="product-flow-grid">
            <div className="product-flow-card" style={{ animationDelay: '0s' }}>
              <div className="product-flow-card-head">
                <span className="product-flow-icon"><Mic size={16} aria-hidden="true" /></span>
                <span>01 / Catch the thought</span>
              </div>
              <div className="product-flow-chat-bubble">
                “We polished setup for weeks. People still got stuck on the empty screen after it.”
              </div>
              <div className="product-flow-input"><span>Say it messy. That's enough.</span><ArrowUp size={14} aria-hidden="true" /></div>
            </div>

            <ArrowRight className="product-flow-arrow" size={20} aria-hidden="true" />

            <div className="product-flow-card" style={{ animationDelay: '-8s' }}>
              <div className="product-flow-card-head">
                <span className="product-flow-icon"><Sparkles size={16} aria-hidden="true" /></span>
                <span>02 / Find your angle</span>
              </div>
              <div className="product-flow-draft">
                <span className="product-flow-draft-label">Creator Chat · draft</span>
                <p>We kept polishing onboarding. The real drop-off came after setup, when the screen was empty.</p>
              </div>
              <div className="product-flow-action"><span>Make it more specific</span><ArrowRight size={13} aria-hidden="true" /></div>
            </div>

            <ArrowRight className="product-flow-arrow" size={20} aria-hidden="true" />

            <div className="product-flow-card" style={{ animationDelay: '-4s' }}>
              <div className="product-flow-card-head">
                <span className="product-flow-icon"><CalendarDays size={16} aria-hidden="true" /></span>
                <span>03 / You decide</span>
              </div>
              <div className="product-flow-queue">
                <span className="product-flow-queue-dot" />
                <div><strong>Ready for review</strong><p>One draft, still yours to edit.</p></div>
              </div>
              <div className="product-flow-approve"><Check size={14} aria-hidden="true" /> Approve for queue</div>
            </div>
          </div>
          <p className="mt-5 text-center text-xs text-muted-foreground">Drafts stay in your hands before they go anywhere.</p>
        </div>
      </div>
    </section>
  )
}
